export function getCookie(name: string): string | null {
	if (typeof document === "undefined") return null;
	const match = document.cookie
		.split(";")
		.map((segment) => segment.trim())
		.find((segment) => segment.startsWith(`${name}=`));
	if (!match) return null;
	const value = match.split("=")[1] ?? "";
	try {
		return decodeURIComponent(value);
	} catch {
		return value;
	}
}

export function getCfAccessToken(): string | null {
	const cookieName =
		(import.meta.env.VITE_CF_JWT_COOKIE_NAME as string | undefined) ||
		"CF_Authorization";
	return getCookie(cookieName);
}

export function buildDefaultHeaders(): Record<string, string> {
	const headers: Record<string, string> = {};
	const token = getCfAccessToken();
	if (token) {
		headers["CF-Access-JWT-Assertion"] = token;
	}
	return headers;
}
